import { create } from '../../../../services/api';

export default (episodeId, customTraceId) => {
  return create
    .get(`/api-v3/episodes/${episodeId}/download-url?`)
    .query({ customTraceId })
    .then(response => {
      window.open(response.body.downloadUrl, '_blank', 'noopener');
    });
};
